let libraryPromise

function loadHighlighter() {
  if (window.hljs) return Promise.resolve(window.hljs)
  const script = document.getElementById("syntax-highlighter")
  if (!script || document.readyState === "complete") return Promise.resolve(null)
  if (!libraryPromise) {
    libraryPromise = new Promise(resolve => {
      const finish = () => {
        clearTimeout(timeout)
        script.removeEventListener("load", finish)
        script.removeEventListener("error", finish)
        resolve(window.hljs || null)
      }
      const timeout = setTimeout(finish, 10_000)
      script.addEventListener("load", finish)
      script.addEventListener("error", finish)
    })
  }
  return libraryPromise
}

export async function highlightCodeWithin(root) {
  const blocks = root.matches("pre code") ? [root] : Array.from(root.querySelectorAll("pre code"))
  const pending = blocks.filter(block => block.dataset.highlighted !== "yes" && !block.classList.contains("nohighlight"))
  if (!pending.length) return
  const library = await loadHighlighter()
  if (!library) return // A failed CDN load leaves the full escaped text readable.
  for (const block of pending) {
    if (!block.isConnected || block.dataset.highlighted === "yes" || block.classList.contains("nohighlight")) continue
    const text = block.textContent
    if (text.length > 300_000 || new TextEncoder().encode(text).byteLength > 300_000) {
      block.classList.add("nohighlight")
      continue
    }
    library.highlightElement(block)
  }
}
